import {
    ChangeDetectionStrategy,
    Component,
    input,
} from "@angular/core";
import { Icon } from "@Front-end/seed/models/icons";
import { EmblaOptionsType } from "embla-carousel";
import { SliderV2Directive } from "../../../../shared/slider-v2/slider-v2.directive";
import { footerSliderConfig } from "../constants/footer-slider";

@Component({
    selector: "ls-footer-slider",
    imports: [
        SliderV2Directive,
    ],
    templateUrl: "./footer-slider.component.html",
    styleUrl: "./footer-slider.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        class: "partners-slider",
    },
})
export class FooterSliderComponent {
    public readonly list = input.required<Icon[] | null>();

    public readonly config: EmblaOptionsType = footerSliderConfig;
}
